// extracted by mini-css-extract-plugin
export var childrenContainer = "_d0-0";
export var virtualScrollArea = "_d0-1";